<div class="vipinfo-colors-wrapper">
  <div class="d-flex flex-column">
    <ng-container *ngIf="hasDefaultButton()">
      <div *ngFor="let category of vipInfoEditColorsDisplay | keyvalue; let i = index">
        <ng-container *ngIf="category.key === 'Buttons'">
          <p class="category-key">
            <b>{{ category.key }}</b>
          </p>
          <br />
          <div class="py-3">
            <span><b>Button styles</b></span>
          </div>
          <div *ngFor="let colorDisplay of category.value; let j = index" class="d-flex flex-column py-2">
            <div *ngIf="j === 5" class="py-3">
              <span><b>Popup styles</b></span>
            </div>
            <div class="d-flex justify-content-between px-3">
              <label style="flex: 1" [for]="'color-' + j">{{ colorDisplay.label }}</label>
              <input
                class="colorpicker-input"
                (colorPickerClose)="onColorChange(category.key, colorDisplay.property, $event)"
                [value]="defaultButton.styles[colorDisplay.property] || '#ffffff'"
                [(colorPicker)]="defaultButton.styles[colorDisplay.property]"
                [style.background]="defaultButton.styles[colorDisplay.property] || '#ffffff'" />
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="hasLinkButton()">
      <div *ngFor="let category of vipInfoEditColorsDisplay | keyvalue; let i = index">
        <ng-container *ngIf="category.key === 'Links'">
          <p class="category-key">
            <b>{{ category.key }}</b>
          </p>
          <br />
          <div
            *ngFor="let colorDisplay of category.value; let k = index"
            class="d-flex justify-content-between px-3 py-2">
            <label style="flex: 1" [for]="'color-' + k">{{ colorDisplay.label }}</label>
            <input
              class="colorpicker-input"
              (colorPickerClose)="onColorChange(category.key, colorDisplay.property, $event)"
              [(colorPicker)]="linkButton.styles[colorDisplay.property]"
              [value]="linkButton.styles[colorDisplay.property] || '#ffffff'"
              [style.background]="linkButton.styles[colorDisplay.property] || '#ffffff'" />
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
